import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { projectContext, loadingContext, urlValue, unfolder, onImportExcelAsync, openAlert, closeAlert } from '../lib'
import SelectCodeModal from './SelectCodeModal'
import '../styles/styles.css'
import '../styles/answerCRUD.scss'
import Loading from './Loading'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ChatBot2 from "./ChatBot2";
import BoxInfo from './common/BoxInfo'
import { Alerts } from './common/Alerts'
import Button from './provider/button/button.jsx'

export function AnswerCRUD({
  sidePanel,
  setSidePanel,
  title,
  edit,
  selectedAnswer,
  setSelectedAnswer,
  isModalOpen,
  setIsModalOpen,
}) {
  const [panel, setPanel] = useState('')
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [loading, setLoading] = useContext(loadingContext)
  const [error, setError] = useState({ name: "" })
  const [audioA, setAudioA] = useState(null)
  const [defaultSentiment, setDefaultSentiment] = useState('')
  const [voiceSelected, setVoiceSelected] = useState(null)
  const [modalCode, setModalCode] = useState({code: false})
  const [alert, setAlert] = useState({title: '', visible: false})
  const contentRef = useRef();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors
  } = useForm({
    defaultValues: {
      technical: ' ',
      type: '1',
    },
  })

  useEffect(() => {
    setValue('code', selectedAnswer.code)
    setValue('name', selectedAnswer.name)
    setValue('content', selectedAnswer.content.text)
    setValue('style', selectedAnswer.style)
    setValue('rate', selectedAnswer?.rate || '1%')
    setValue('pitch', selectedAnswer?.pitch || '1%')
    setValue('volume', selectedAnswer?.volume || '1%')
    setValue('type', `${1}`)

    document.querySelector("#rate_rg").value = selectedAnswer?.rate?.replace("%", "").replace("+", "") || 1;
    document.querySelector("#pitch_rg").value = selectedAnswer?.pitch?.replace("%", "").replace("+", "") || 1;
    document.querySelector("#volume_rg").value = selectedAnswer?.volume?.replace("%", "").replace("+", "") || 1;
    setDefaultSentiment(selectedAnswer?.default_sentiment || '');
    // setValue('locale', selectedProject.metadata.language)
    // setValue('technical', selectedAnswer.technical_text)
    // setValue('style', selectedAnswer.style)
  }, [selectedAnswer])

  useEffect(() => {
    setPanel(sidePanel)
  }, [sidePanel])

  const handleCancel = () => {
    setSelectedAnswer({ content: {} })
    clearErrors()
    setSidePanel('new')
  }

  const onSubmit = data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._'()-¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: "The name cannot contain symbols and special characters." })
    }

    if (ok) {
      setLoading(true)
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
      const dataSend = {
        id: selectedAnswer.id,
        code: data.code,
        name: data.name,
        type: parseInt(1),
        content: {
          text: data.content,
        },
        style: data.style,
        rate: data.rate,
        pitch: data.pitch,
        volume: data.volume,
        technical_text: "{}",
        locale: "en-US",
        project: selectedProject.id,
        channel: 1,
        edited_by: id,
        user_id: id,
        ccms_name: ccms_name,
        last_update: '2022-02-24',
        transactional: 0,
        webhook: null,
        default_sentiment: defaultSentiment
      }
      axios({
        method: panel == 'edit' ? 'put' : 'post',
        url: `${urlValue}/studio/answer`,
        headers: {
          user: id,
          'Content-Type': 'application/json',
          'access-token': token,
          projectid: selectedProject.id,
        },
        data: dataSend,
      })
        .then(function (response) {
          openAlert('#alert-ac', () => {setAlert({title: 'Answer have been change properly!', visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
   
          setSelectedAnswer(dataSend)
          setSidePanel('detail')
          setLoading(false)
        })
        .catch(function (error) {
          console.log(error)
          openAlert('#alert-ac', () => {setAlert({title: 'Answer could not save!!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
          setLoading(false)
        })
    }
  }

  const [AnswersExcel, setAnswersExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)


  const uploadMaxive = async () => {

    if (!loadingUpload && AnswersExcel.length > 0 && AnswersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        for (var i = 0; i < AnswersExcel.length; i++) {
          const rest = await axios({
            method: panel == 'edit' ? 'put' : 'post',
            url: `${urlValue}/studio/answer`,
            headers: {
              user: id,
              'Content-Type': 'application/json',
              'access-token': token,
              projectid: selectedProject.id,
            },
            data: {
              id: null,
              code: AnswersExcel[i].Code,
              name: AnswersExcel[i].Name?.trim(),
              type: parseInt(AnswersExcel[i].Type),
              content: {
                text: AnswersExcel[i].Content,
              },
              technical_text: AnswersExcel[i].Technical_Text,
              locale: AnswersExcel[i].Locale,
              project: selectedProject.id,
              channel: 1,
              edited_by: null,
              last_update: '2022-02-24',
              transactional: 0,
              webhook: null,
            },
          })
        }

        window.location.reload();
      }, 1000)

    } else {
      alert("Cannot insert more than 100 lines")
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);
    setAnswersExcel(DatosExcel);
    uploadMaxive();
  }

  const convertRangeRate = (e) => {
    setValue('rate', e.target.value + '%');
  }

  const convertRangePitch = (e) => {
    setValue('pitch', e.target.value + '%');
  }

  const convertRangeVolume = (e) => {
    setValue('volume', '+' + e.target.value + '.00%');
  }

  const playAnswer = async () => {
    let tokenN = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    
    let voice = voiceSelected.voice;
    
    const resToke = await axios.post(`https://eastus.api.cognitive.microsoft.com/sts/v1.0/issuetoken`, {}, {
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
      }
    })
    let token = resToke.data;
    
    const resVoices = await axios({
      method: 'get',
      url: 'https://eastus.tts.speech.microsoft.com/cognitiveservices/voices/list',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
        Authorization: `Bearer ${token}`,
      }
    })

    /* const res = await axios({
       method: 'post',
       url: 'https://eastus.tts.speech.microsoft.com/cognitiveservices/v1',
       data:
 
         `<speak version='1.0' xml:lang='es-PR'>
           <voice xml:lang='es-PR' xml:gender='Male'  name='es-PR-VictorNeural'>
             Microsoft Speech Service Text-to-Speech API
           </voice>
        </speak>`,
 
       headers: {
         'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
         Authorization: `Bearer ${token}`,
         'cache-control': 'no-cache',
         // 'X-Microsoft-OutputFormat': 'riff-8khz-8bit-mono-alaw',
         'X-Microsoft-OutputFormat': 'riff-8khz-8bit-mono-alaw',
         'Content-Type': 'application/ssml+xml'
       }
     })*/

    //let audioBlob = new Blob([res.data], { type: "audio/mpeg" });
    //  var blobURL = window.URL.createObjectURL(audioBlob);
    // document.getElementById("wavSource").src = blobURL;
    // var source = document.getElementById('audioID');
    // source.src = blobURL;
    //source.play();
    // var audio = new Audio(blobURL);
    // audio.play();

    //setAudioA(blobURL)
    const contentAws = document.querySelector("#contentAws");
    const pitch = document.querySelector("#pitch")?.value;
    const style = document.querySelector("#style")?.value;
    const rate = document.querySelector("#rate")?.value;
    const volume = document.querySelector("#volume")?.value;
    
    if (contentAws?.value !== "") {

      let speaker1 = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
                          xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
                        <voice name="${voice?.trim()?.replaceAll('_', '-')}">
                            <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                                <mstts:express-as style="${style}">
                                    ${contentAws?.value}
                                </mstts:express-as>
                            </prosody>
                        </voice>
                     </speak>`

      try {
        let speaker = `<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="en-US"><voice name="es-PR-VictorNeural"><prosody rate="0%" pitch="0%">Puede reemplazar este texto por el que desee. Puede escribir o pegar su propio texto en este cuadro de texto.

        Pruebe diferentes idiomas y voces. Cambie la velocidad y el tono de la voz. </prosody></voice></speak>`

        const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
          method: 'POST',
          headers: {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
            Authorization: `Bearer ${token}`,
            'cache-control': 'no-cache',
            'X-Microsoft-OutputFormat': 'riff-8khz-8bit-mono-alaw',
            'Content-Type': 'application/ssml+xml'
          },
          body: speaker1
        });
        if (!res3.ok) {
          throw new Error('Fetch failed!');
        }
        const wavFile = await res3.blob();
        document.querySelector('#audioID').src = URL.createObjectURL(wavFile);
        document.querySelector('#audioID').play();
      } catch (error) {
        console.log(error)
      }


    }

  }

  const changeSentiment = (sentiment, e) => {
    setDefaultSentiment(sentiment)
    
  }

  const getVoiceProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    const res = await axios.post(`${urlValue}/studio/answer/voice/selected`,
      { id: selectedProject.voice_id },
      {
        headers: {
          user: id,
          'Content-Type': 'application/json',
          'access-token': token,
          projectid: selectedProject.id,
        }
      });
    
    if (res.status === 200) {
      setVoiceSelected(res.data)
    }
  }
  useEffect(() => {
    getVoiceProject()
  }, [])
  return (
    <>
      <ChatBot2 project={selectedProject} />

      <div className="answerCRUD  ">
        <div className="scroll-internal ">
          <h2 style={{ color: "#0B5FA3" }}>{title}</h2>
          <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-row flex-wrap">

            <div className="w-full items-center">
              <div className="flex flex-row w-full flex-1 items-center">
                <div className="inputs flex ">
                  <div className="input">
                    <div className="flex">
                      <span>Code:</span>
                      <img id="code-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                      <Tooltip events={['click']} anchorId="code-tp" content={`Pair the answer with the respective intent name`} place="top" />
                    </div>
                    <div
                      onClick={ ()=>{ edit ? setModalCode({ code: true }) : <></> } }
                      className={ edit ?  'pointer' : "" }
                    >
                      <input
                        className='input-data'
                        {...register('code', { required: true })}
                        type="text"
                        disabled={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs flex flex-1 ml-5">
                  <div className="input tooltip">
                    <span>Name:</span>
                    <input
                      id='name-tp'
                      placeholder='Enter the Answer name'
                      className='input-data'
                      {...register('name', { required: true })}
                      type="text"
                      disabled={!edit}
                    />
                    <Tooltip anchorId="name-tp" content={`Only these characters are accepted A-Za-z0-9-,._'¿? `} place="top" />
                    {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿? <div className='triangulo'></div></span> */}
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full flex-1 mt-4">
                <div className="inputs" style={{ width: '100%' }}>
                  <div className="input" id="textarea">
                    <span className=''>Content</span>
                    <textarea
                      id="contentAws"
                      placeholder='Enter the answer text the AI will provide'
                      {...register('content', { required: true })}
                      type="text"
                      disabled={!edit}
                      className='input-data'
                      style={{ height: 250 }}
                    />
                    {/* <Tooltip anchorId="contentAws" content={`Enter the answer text the AI will provide`} place="top" /> */}
                  </div>

                </div>
              </div>
            </div>

            <div className="flex flex-row items-center w-full flex-1 mt-4" style={{ paddingRight: 20 }}>
              <div className="inputs" style={{ width: 'auto' }}>
                <div className="input" >
                  <div className="flex flex-row items-center" >
                    <span>Default to:</span>
                    <img id="default-tp" src={'/icons/tooltip-indicator-icon.svg'} style={{ width: 15, height: 15, cursor: 'pointer', objectFit: 'fill', marginLeft: 7 }} className="cursor-pointer w-[15px] h-[15px] object-fill ml-[7px]" alt="" />
                  </div>

                  <Tooltip events={['click']} anchorId="default-tp" html={`
                <div style='color: white;'>                
                Default to: <br />
                Level 1: The user is unsatisfied  <br />
                Level 2: The user is a mildly unsatisfied  <br />
                Level 3: The user is neutral  <br />
                Level 4: The user is mildly satisfied <br />
                Level 5: The user is satisfied </div>`} place="top" />

                </div>
              </div>
              <img className={`${defaultSentiment === 'unfriendly' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('unfriendly', e)} src='/icons/status-1.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
              <img className={`${defaultSentiment === 'sad' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('sad', e)} src='/icons/status-2.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
              <img className={`${defaultSentiment === 'friendly' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('friendly', e)} src='/icons/status-3.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
              <img className={`${defaultSentiment === 'cheerful' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('cheerful', e)} src='/icons/status-4.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
              <img className={`${defaultSentiment === 'excited' && 'set-sentiment'} opa-icon ml-2`} onClick={(e) => changeSentiment('excited', e)} src='/icons/status-5.png' alt='icon' style={{ objectFit: "contain", width: "29px", cursor: "pointer" }} />
            </div>
            <div className="w-100   d-flex flex-wrap mt-3 pt-3 pb-3" style={{ paddingRight: 22, width: '100% !important', borderTop: '1px solid #707070', }}>

              <div className='flex flex-row items-center '>
                <span style={{ fontSize: 20 }} className="title-crud">Modulation:</span>
                <button className="btn-nesting ml-5 mr-3" type="button" onClick={() => { playAnswer() }}> Play </button>
                <audio id="audioID" controls >
                  <source type="audio/mpeg" />
                </audio>
              </div>
              <div className="input w-100 d-flex flex-row flex-wrap justify-space-between">
                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <BoxInfo
                    id="style-tp"
                    titleClass='mr-0-3 color-label f-16  title-intent'
                    title="Style:"
                    place="top"
                    containerClass='mr-0-1 z-15 '
                    render={`<div> Here you can select the best speech style <br /> for your project from the options below </div>`}
                  />
                  <div className="select ml-3">
                    <select id="style" className="w-100   select-nesting input-data" {...register('style', { required: false })}
                      style={{ minWidth: 220, padding: 8 }}>
                      <option value="angry">Angry</option>
                      <option value="cheerful">Cheerful</option>
                      <option value="excited">Excited</option>
                      <option value="fearful">Fearful</option>
                      <option value="friendly">Friendly</option>
                      <option value="hopeful">Hopeful</option>
                      <option value="unfriendly">Unfriendly</option>
                      <option value="sad">Sad</option>
                      <option value="terrified">Terrified</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <label htmlFor="rate" className='list-color'>Rate:</label>
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" onChange={convertRangeRate} id="rate_rg" className="ml-2" />
                    <input type="text"  {...register('rate', { required: false })} id="rate" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <label htmlFor="pitch" className='list-color'>Pitch:</label>
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" id="pitch_rg" onChange={convertRangePitch} className="ml-2" />
                    <input type="text" {...register('pitch', { required: false })} id="pitch" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>

                <div className="d-flex flex-row align-items-center mt-2" style={{ width: '40%', minWidth: 250 }}>
                  <label htmlFor="volume" className='list-color'>Volume:</label>
                  <div className="d-flex flex-row pl-2" style={{ maxWidth: 100 }}>
                    <input type="range" id="volume_rg" onChange={convertRangeVolume} className="ml-2" style={{ maxWidth: 110 }} />
                    <input type="text" {...register('volume', { required: false })} id="volume" className="ml-3 input-data"
                      style={{ maxWidth: 80, paddingLeft: 10 }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer">
              <div className='cont-buttons'>
                {edit &&
                  (errors.code ||
                    errors.name ||
                    errors.locale ||
                    errors.content ||
                    errors.technical) ? (
                  <span className='errors-msg'>All fields are required</span>
                ) : (
                  <span> </span>
                )}
                <span className='errors-msg'  >{error.name}</span>
              </div>
              <div className="buttons">
                <Button 
                  type="button"
                  label='Cancel'
                  className='create btn-bottom btn-bottom-cancel'
                />

                <Button 
                  type="submit"
                  label={edit ? 'Save' : 'Create'}
                  className='create btn-bottom btn-bottom-create'
                />

                {/*
                <button className="create btn-bottom btn-bottom-cancel" type="submit" style={{ backgroundColor: "#002565" }}>
                <button className="create btn-bottom btn-bottom-cancel" type="button" onClick={(handleCancel)} style={{ backgroundColor: "#002565" }}>
                  Cancel
                </button>
                
                <button className="create btn-bottom btn-bottom-create" type="submit">
                  {edit?'Save': 'Create'}
                </button>
                */}

                {/* {panel == 'edit' ? (
                <> */}
                {/* <button
                    className="cancel"
                    type="button"
                    onClick={() => setSidePanel('detail')}
                  >
                    Cancel
                  </button>
                  <button className="create" type="submit">
                    Confirm
                  </button> */}
                {/* </>
              ) : panel == 'new' ? (
                <> */}
                {/* <button
                    className="cancel"
                    type="button"
                    onClick={() => setSidePanel('detail')}
                  >
                    Cancel
                  </button> */}
                {/* <button className="create" type="submit">
                    Save
                  </button> */}
                {/* </>
              ) : (
                selectedAnswer.id && ( */}
                {/* <button
                    className="create"
                    type="button"
                    onClick={() => setSidePanel('edit')}
                  >
                    Edit
                  </button> */}
                {/* )
              )} */}
              </div>
            </div>
          </form>
        </div>
       
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
      </div>
     {modalCode.code&& <SelectCodeModal
        isModalOpen={modalCode}
        setIsModalOpen={setModalCode}
        setValue={setValue}
      />}

    </>
  )
}
